/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type BulkInvite_org = {
    readonly id: string;
    readonly orgPersonListPaginatedErrorable: {
        readonly __typename: "OrgPersonListPaginated";
        readonly persons: ReadonlyArray<{
            readonly personId: string;
            readonly primaryCalendarId: string;
            readonly userId: string | null;
            readonly profile: {
                readonly givenName: string | null;
                readonly familyName: string | null;
                readonly externalImageUrl: string | null;
            } | null;
        }> | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly " $refType": "BulkInvite_org";
};
export type BulkInvite_org$data = BulkInvite_org;
export type BulkInvite_org$key = {
    readonly " $data"?: BulkInvite_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"BulkInvite_org">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [
        {
            "defaultValue": "",
            "kind": "LocalArgument",
            "name": "queryInput"
        }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "BulkInvite_org",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": [
                {
                    "kind": "Literal",
                    "name": "excludeNonUsers",
                    "value": false
                },
                {
                    "kind": "Literal",
                    "name": "freePersonsOnly",
                    "value": true
                },
                {
                    "kind": "Literal",
                    "name": "limit",
                    "value": 20
                },
                {
                    "kind": "Variable",
                    "name": "searchQuery",
                    "variableName": "queryInput"
                },
                {
                    "kind": "Literal",
                    "name": "sortDirection",
                    "value": "Ascending"
                },
                {
                    "kind": "Literal",
                    "name": "sortType",
                    "value": "FullName"
                }
            ],
            "concreteType": null,
            "kind": "LinkedField",
            "name": "orgPersonListPaginatedErrorable",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "OrgPerson",
                            "kind": "LinkedField",
                            "name": "persons",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "personId",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "primaryCalendarId",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "userId",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UserProfile",
                                    "kind": "LinkedField",
                                    "name": "profile",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "givenName",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "familyName",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "externalImageUrl",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "type": "OrgPersonListPaginated",
                    "abstractKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Org",
    "abstractKey": null
} as any;
(node as any).hash = '707ceccda06e4fc45a0be54fc9761dea';
export default node;
